import Project1 from '../assets/hrms.jpg';
import Project2 from '../assets/diabetic.jpg'; 
import Project3 from '../assets/attendance.jpg'; 
import { motion } from 'framer-motion';

export default function Projects() {
  const projects = [
    {
      img: Project1,
      desc: "Developed HRMS and CRM modules using React.js, improving client workflows and dashboard usability. Designed interactive, reusable UI components, optimizing rendering performance and improved loading time by 20%.",
      href: "https://github.com/TechJarvis/HRMS-frontend"
      
    },
    {
      img: Project2,
      desc: "Designed a CNN model to classify retinal fundus images into stages of diabetic retinopathy. Used TensorFlow for training, preprocessing, and data augmentation for better diagnostic accuracy.",
      href: "https://github.com/PriyadharshniG/diabetic_retinopathy"
      
    },
    {
      img: Project3,
      desc: "Built an automated attendance system using LBPH algorithm for facial recognition. Ensured accuracy across various lighting conditions using real-time detection.",
      href: "https://github.com/PriyadharshniG/face-recognition-attendance-system-main"
      
    }
  ];

  return (
    <section id="projects" className="flex flex-col py-20 px-5 justify-center bg-secondary shadow-2xl text-white">
      <div className="w-full">
        <div className="flex flex-col px-10 py-5">
          <h1 className="text-4xl border-b-4 border-pink-400 w-[150px] font-bold mb-5">Projects</h1>
          <p className="text-lg text-pink-100">
            These are some of my projects developed using Python, MERN stack, and other technologies. They reflect my technical skills and problem-solving capabilities. Check them out!
          </p>
        </div>
      </div>

      <div className="w-full">
        <div className="flex flex-col md:flex-row justify-center items-center gap-10 px-5 md:px-20 flex-wrap">
          {projects.map((project, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.05 }}
              className="backdrop-blur-xl bg-white/10 border border-white/20 rounded-2xl shadow-xl p-5 transition-all duration-300 w-[90%] md:w-[500px] hover:bg-white/20"
            >
              <img src={project.img} className="h-[200px] w-full object-cover rounded-xl" alt={`Project ${index + 1}`} />
              <p className="text-center px-3 py-4 text-pink-100 text-base">
                {project.desc}
              </p>
              {project.href && (
                <div className="text-center mt-2">
                  <a
                    href={project.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-pink-300 underline hover:text-pink-400"
                  >
                    View Project
                  </a>
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
